
import React, {Suspense} from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";

// styles
import "assets/css/bootstrap.min.css";
import "assets/scss/paper-kit.scss";
import "assets/demo/demo.css";
// pages
import LandingPage from "views/examples/LandingPage.js";
import AboutUs from "views/examples/AboutUs.js";
import RegisterPage from "views/examples/RegisterPage.js";
import Trucks from 'views/examples/Trucks';
import Containers from 'views/examples/Containers';
import WaterTruck from 'views/examples/WaterTruck';
import Train from 'views/examples/Train';
import OurProjects from 'views/examples/OurProjects'
import Services from 'views/examples/Services'
// others
import './i18next';

ReactDOM.render(
  <Suspense fallback={(<div>Loading...</div>)}>
  <BrowserRouter>
    <Switch>
      <Route 
        path="/index"
        render={props => <LandingPage {...props} />} />
      <Route
        path="/profile-page"
        render={props => <AboutUs {...props} />}
      />
      <Route
        path="/register-page"
        render={props => <RegisterPage {...props} />}
      />
      <Route
        path="/trucks"
        render={props => <Trucks {...props} />}
      />
      <Route
        path="/containers"
        render={props => <Containers {...props} />}
      />
      <Route
        path="/water-truck"
        render={props => <WaterTruck {...props} />}
      />
      <Route
        path="/train"
        render={props => <Train {...props} />}
      />
      <Route
        path="/our-projects"
        render={props => <OurProjects {...props} />}
      />
      <Route
        path="/services"
        render={props => <Services {...props} />}
      />
      <Redirect to="/index" />
    </Switch>
  </BrowserRouter>
  </Suspense>,
  document.getElementById("root")
);
